import type { FaireCollectionEntity } from "../../entity_types/collection";

export const col_candles_holders: FaireCollectionEntity = {
  token: "col_candles-holders",
  type: "collection",
  name: "Candles & Holders",
  description: "Ambient lighting and decorative candle accessories.",
  thumbnailUrl:
    "https://images.unsplash.com/photo-1602874801007-bd458bb1b8b6?w=400&h=400&fit=crop",
  season: "everyday",
  itemCount: 84,
  brandToken: "catalog_brand_audreys_home_gift",
  productTokens: [],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
